import axios from 'axios';
import { Dispatch, FormEvent, SetStateAction, useState } from 'react';
import { ArrowPolygon, Flexed, Select } from '../../../styles/GlobalComponents';
import { Icon } from '../../../styles/Icons';
import { color } from '../../../styles/GlobalStyles';
import { useAppSelector } from '../../../app/hooks';

export const ChooseWithdraw = ({
  setStep,
  setIsUSDTBalance,
  setNoKyc,
  setFee,
  setSelectedNetwork
}: {
  setStep: Dispatch<SetStateAction<number>>;
  setIsUSDTBalance: Dispatch<SetStateAction<boolean>>;
  setNoKyc: Dispatch<SetStateAction<boolean>>;
  setFee: Dispatch<SetStateAction<number>>;
  setSelectedNetwork: any;
}) => {
  const { kycStatus } = useAppSelector((state) => state.auth.userInfo);

  const { withdrawAvailability, withdrawMLPAvailability } = useAppSelector(
    (state) => state.earnings
  );
  return (
    <Flexed column>
      <Select
        isOpen={false}
        onClick={() => {
          if (kycStatus.isKycCompleted) {
            if (withdrawAvailability) {
              setIsUSDTBalance(true);
              setStep(1);
            } else {
              setStep(9);
            }
          } else {
            setNoKyc(true);
          }

          setFee(5);
          setSelectedNetwork('');
        }}>
        <div style={{ color: color.colors.neutral700 }}>
          USDT Balance Withdraw
        </div>

        <>
          <ArrowPolygon
            direction={'right'}
            customColor={color.colors.neutral700}
          />
        </>
      </Select>

      <Select
        isOpen={false}
        onClick={() => {
          if (kycStatus.isKycCompleted) {
            if (withdrawMLPAvailability) {
              setIsUSDTBalance(false);
              setStep(1);
            } else {
              setStep(9);
            }
          } else {
            setNoKyc(true);
          }
          setFee(5);
          setSelectedNetwork('');
        }}>
        <div style={{ color: color.colors.neutral700 }}>
          Finup Balance Withdraw
        </div>

        <>
          <ArrowPolygon
            direction={'right'}
            customColor={color.colors.neutral700}
          />
        </>
      </Select>
    </Flexed>
  );
};
